import { track } from "src/client/js/analytics/facade";

export const trackOpenCanvas = (productId) =>
  track("Click_submit_to_preview", {
    label: `${productId}`,
    category: "Canvas",
  });

export const trackErrorCanvas = (fieldName, errorMessage) =>
  track("Errors", {
    label: `Field name: ${fieldName} / Error message: ${errorMessage}`,
    category: "Canvas",
  });
